import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOrganization, IOrganizationSelector } from "../../../models/catalog";

interface ICatalogState {
    organizations: IOrganizationSelector;
}

const initialState: ICatalogState = {
    organizations: {
        data: [],
        loading: false,
    },
};

export const catalogReducer = createSlice({
    name: "catalogReducer",
    initialState,
    reducers: {
        resetCatalog: () => initialState,
        setCatalogOrganization: (state, action: PayloadAction<IOrganization[]>) => {
            state.organizations.data = action.payload
        },
        setLoadingCatalogOrganization: (state, action: PayloadAction<boolean>) => {
            state.organizations.loading = action.payload
        },
    },
});

export const { resetCatalog, setCatalogOrganization, setLoadingCatalogOrganization } = catalogReducer.actions;

export default catalogReducer.reducer;
